import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DealerProfile } from '@app/domain/model/dealer-profile';

@Component({
  selector: 'app-admin-dealer-query-reports',
  templateUrl: './admin-dealer-query-reports.component.html',
  styleUrls: ['./admin-dealer-query-reports.component.scss']
})
export class AdminDealerQueryReportsComponent implements OnInit {

  profile: DealerProfile;

  constructor(private readonly formBuilder: FormBuilder,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.parent.data.subscribe((data) => {
      this.profile = data.profile;
    });
  }

}
